export default "__VITE_ASSET__C7p0_pQP__"